import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.l3q_1 = new (MarkdownContent())('aboutMd', 'connectSuccessMd', 'contributionStartMd', 'boostMd', 'recentInfoMd', 'installSuccessMd');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var MarkdownContentClass;
function MarkdownContent() {
  if (MarkdownContentClass === VOID) {
    class $ {
      constructor(aboutMd, connectSuccessMd, contributionStartMd, boostMd, recentInfoMd, installSuccessMd) {
        Companion_getInstance();
        this.m3q_1 = aboutMd;
        this.n3q_1 = connectSuccessMd;
        this.o3q_1 = contributionStartMd;
        this.p3q_1 = boostMd;
        this.q3q_1 = recentInfoMd;
        this.r3q_1 = installSuccessMd;
      }
      toString() {
        return 'MarkdownContent(aboutMd=' + this.m3q_1 + ', connectSuccessMd=' + this.n3q_1 + ', contributionStartMd=' + this.o3q_1 + ', boostMd=' + this.p3q_1 + ', recentInfoMd=' + this.q3q_1 + ', installSuccessMd=' + this.r3q_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.m3q_1);
        result = imul(result, 31) + getStringHashCode(this.n3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r3q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MarkdownContent()))
          return false;
        if (!(this.m3q_1 === other.m3q_1))
          return false;
        if (!(this.n3q_1 === other.n3q_1))
          return false;
        if (!(this.o3q_1 === other.o3q_1))
          return false;
        if (!(this.p3q_1 === other.p3q_1))
          return false;
        if (!(this.q3q_1 === other.q3q_1))
          return false;
        if (!(this.r3q_1 === other.r3q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MarkdownContent');
    MarkdownContentClass = $;
  }
  return MarkdownContentClass;
}
//region block: exports
export {
  MarkdownContent as MarkdownContent25fmztzs0fh3a,
  Companion_getInstance as Companion_getInstance3kqyk8vnxc5xb,
};
//endregion

//# sourceMappingURL=MarkdownContent.mjs.map
